module.exports = __webpack_public_path__ + "static/media/rock.927ee8f5.jpg";